import React from 'react'
import ReactModal from 'react-modal'
import { Form } from 'react-bootstrap'
import numeral from 'numeral'
import CloseBtn from '../buttons/CloseBtn'
import RequieredInputs from '../common/RequiredInputs'
import DateField from '../fields/DateField/DateField'
import CurrencyInput from '../common/CurrencyInput'
import { BusinessUnitMultiSelect } from '../fields'

const EventsModal = ({
  modalIsOpen,
  closeModal,
  inputs,
  handleChange,
  handleSubmit,
  validateForm,
  textBtn,
  businessunits = [],
  isEdit = false,
  isViewMode = false,
}) => {
  // Función para validar y formatear fechas
  const handleDateChange = (event) => {
    const { value } = event.target

    // Si el valor está vacío, permitirlo
    if (!value) {
      handleChange(event)
      return
    }

    // Validar formato de fecha YYYY-MM-DD (solo formato, no rango)
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/
    if (dateRegex.test(value)) {
      handleChange(event)
    } else {
      // No actualizar si no tiene el formato correcto
      console.warn('Formato de fecha inválido, debe ser YYYY-MM-DD')
    }
  }
  const customStyles = {
    overlay: {
      zIndex: 4,
    },
    content: {
      width: '90%',
      maxHeight: '90vh',
      padding: '25px',
      overflow: 'auto',
    },
  }

  // Títulos dinámicos según el modo
  const modalTitle = isViewMode
    ? 'Ver evento'
    : isEdit
    ? 'Editar evento'
    : 'Crear nuevo evento'
  const contentLabel = isViewMode
    ? 'Ver evento'
    : isEdit
    ? 'Editar evento'
    : 'Crear nuevo evento'

  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel={contentLabel}
      className='custom-modal'
      style={customStyles}
    >
      <span className='custom-modal__close close-btn' onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className='custom-modal__title'>{modalTitle}</h4>
      <Form onSubmit={handleSubmit} className='modal__form'>
        {/* Contenedor adaptable para todos los campos */}
        <div className='modal-form-container'>
          {/* Nombre del evento */}
          <div className='modal-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Nombre <RequieredInputs />
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='nombre'
                value={inputs.nombre || ''}
                onChange={handleChange}
                placeholder='Nombre del evento'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>

          {/* Ubicación */}
          <div className='modal-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Ubicación <RequieredInputs />
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='ubicacion'
                value={inputs.ubicacion || ''}
                onChange={handleChange}
                placeholder='Ubicación del evento'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>

          {/* Fecha inicio */}
          <div className='modal-form-field modal-form-field--small'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Fecha inicio <RequieredInputs />
              </Form.Label>
              <DateField
                name='fechaInicio'
                value={inputs.fechaInicio || ''}
                onChange={handleDateChange}
                required={true}
                disabled={isViewMode}
              />
            </Form.Group>
          </div>

          {/* Fecha final */}
          <div className='modal-form-field modal-form-field--small'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Fecha final <RequieredInputs />
              </Form.Label>
              <DateField
                name='fechaFinal'
                value={inputs.fechaFinal || ''}
                onChange={handleDateChange}
                required={true}
                disabled={isViewMode}
              />
            </Form.Group>
          </div>

          {/* Coste participación */}
          <div className='modal-form-field modal-form-field--small'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Coste participación
              </Form.Label>
              <CurrencyInput
                value={inputs.coste1 || 0}
                onChange={handleChange}
                name='coste1'
                currency='EUR'
                placeholder='0,00'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>

          {/* Coste equipos */}
          <div className='modal-form-field modal-form-field--small'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>Coste equipos</Form.Label>
              <CurrencyInput
                value={inputs.coste2 || 0}
                onChange={handleChange}
                name='coste2'
                currency='EUR'
                placeholder='0,00'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>

          <br />

            {/* Checkbox */}
            <div className='modal-form-field'>
              <Form.Group>
                <Form.Check
                  type='checkbox'
                  name='isVerCaledario'
                  checked={inputs.isVerCaledario || false}
                  onChange={handleChange}
                  label='Añadir al calendario'
                  className='form-check-input-custom'
                  disabled={isViewMode}
                />
              </Form.Group>
            </div>

          {/* Unidades de Negocio */}
          <div className='modal-form-field'>
            <BusinessUnitMultiSelect
              value={
                inputs.businessUnits && Array.isArray(inputs.businessUnits)
                  ? inputs.businessUnits.map((bu) => bu.id_NegocioUnidad)
                  : []
              }
              onChange={
                isViewMode
                  ? () => {}
                  : (selectedIds) => {
                      // Convertir IDs a objetos business unit
                      const selectedBusinessUnits = selectedIds
                        .map((id) =>
                          businessunits.find(
                            (bu) => bu.id_NegocioUnidad === id,
                          ),
                        )
                        .filter((bu) => bu !== undefined)

                      handleChange({
                        target: {
                          name: 'businessUnits',
                          value: selectedBusinessUnits,
                        },
                      })
                    }
              }
              label='Unidades de Negocio'
              placeholder='Selecciona las unidades de negocio para este evento...'
              required
              compact
              disabled={isViewMode}
            />
          </div>
          <div className='modal-form-field modal-form-field--full-width'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Objetivo <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='textarea'
                rows={2}
                className='user-input form__input'
                name='info3'
                value={inputs.info3 || ''}
                onChange={handleChange}
                placeholder='Objetivo del evento'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>
          {/* Objetivo */}
          <div className='modal-form-field modal-form-field--full-width'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Descripción <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='textarea'
                rows={2}
                className='user-input form__input'
                name='descripcion'
                value={inputs.descripcion || ''}
                onChange={handleChange}
                placeholder='Descripción del evento'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>

          {/* Aspectos positivos */}
          <div className='modal-form-field modal-form-field--textarea'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Aspectos positivos post evento
              </Form.Label>
              <Form.Control
                as='textarea'
                rows={2}
                className='user-input form__input'
                name='info1'
                value={inputs.info1 || ''}
                onChange={handleChange}
                placeholder='Describe los aspectos positivos del evento...'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>

          {/* Aspectos negativos */}
          <div className='modal-form-field modal-form-field--textarea'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Aspectos de mejora post evento
              </Form.Label>
              <Form.Control
                as='textarea'
                rows={2}
                className='user-input form__input'
                name='info2'
                value={inputs.info2 || ''}
                onChange={handleChange}
                placeholder='Describe los aspectos negativos del evento...'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>
        </div>

        <div className='modal-form-actions'>
          {!isViewMode && (
            <button
              onClick={handleSubmit}
              disabled={!validateForm()}
              className='btn save create'
              type='submit'
            >
              {textBtn}
            </button>
          )}
        </div>
      </Form>
    </ReactModal>
  )
}

ReactModal.setAppElement('#root')
export default EventsModal
